import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  next() {
    const card = this.trackTarget.querySelector('.section-personas__card')
    this.trackTarget.scrollBy({ left: (card.offsetWidth + 20) * 3, behavior: 'smooth' })
  }

  prev() {
    const card = this.trackTarget.querySelector('.section-personas__card')
    this.trackTarget.scrollBy({ left: -(card.offsetWidth + 20) * 3, behavior: 'smooth' })
  }
}
